import React, { useContext, useEffect } from 'react';
import { DispatchContext, StateContext } from '@store/store';

import AffiliateLandingPage from '@layouts/AffiliateLandingPage';
import { setRedirectionLink } from '@store/actions';

const pageData = {
  firstName: 'Chris',
  lastName: 'Record',
  mainSection: {
    name: 'Chris Record',
    percentage: '25',
    getOfferTxt: "GET CHRIS' OFFER",
    title: 'Welcome friends of Chris Record!',
    subTitle: 'Your search for the easiest video editor ends here!',
    offerSubTitle: 'Exclusive Chris Record Offer',
    offerTitle: 'Enjoy 25% Off!',
    mainBgImg: {
      desktop:
        'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-desk-bg.png',
      mobile:
        'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record-mobile.png',
    },
  },
  section2: {
    circularImg: true,
    imgCircle: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record-2.webp',
      jpg: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record-2.jpg',
      alt: 'Chris Record invideo',
    },
    content: {
      title:
        'Finally a simple solution to EDIT professional videos in just minutes!',
      p1: 'Chris Record - the video marketing expert is here to help!',
      p2: "The #1 most important tool to help me generate millions of dollars online has been harnessing the power of VIDEOS. Every product I ever launched, every offer I ever promoted as an affiliate, every campaign I've ever used to brand myself, every advertisement I've run to promote my companies, have all used VIDEOS!",
      p3: "But I've always been nervous to TEACH video editing because the software the pros use could take you months, even years to learn properly. That's why I've teamed up with invideo to help my followers edit their videos in just minutes by using a very simple user-friendly interface that allows you to drag-and-drop your videos in, add some elements, save your changes, and publish to YouTube, Facebook, Instagram & more.",
      bold: `"invideo is going to be a game changer for your business!" - Chris Record`,
    },
    creatorLink: '/creator/chrisrecord',
  },
  section3: {
    para: `Imagine being able to shoot a video from your phone, then drag it into a pre-existing template on invideo that already has your video intro & outro, your end screen for YouTube, and more. This would allow you to edit your video in just minutes, rather than hours. And with invideo that's exactly what's possible. This is a game changer for entrepreneurs.`,
    img: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record.webp',
      jpg: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record.jpg',
      alt: 'Chris Record invideo',
    },
  },
  pricing: {
    business: {
      discount: 25,
    },
    unlimited: {
      discount: 25,
    },
  },
  lastSection: {
    img: {
      webp: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record-4.webp',
      png: 'https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/chris-record-4.png',
    },
  },
  cookie: {},
};

const cookie = {
  coupon: 'CR25',
  response: {
    fixed_discount: false,
    amount: 0,
    percent: 25,
    type: 'discount',
    status: 'success',
    referral_id: '',
  },
  duration: true,
};

function Chrisrecord() {
  const dispatch = useContext(DispatchContext);

  useEffect(() => {
    dispatch(setRedirectionLink(`/payments/checkout?coupon=${cookie.coupon}`));
  }, []);

  return (
    <AffiliateLandingPage
      pageData={pageData}
      seo={{
        Title: 'Chris Record | invideo',
        Description:
          'Finally a simple solution to EDIT professional videos in just minutes! Chris Record - the video marketing expert is here to help!',
        CanonicalURL: 'https://invideo.io/chrisrecord/',
        Keywords: '',
        Hreflang: [],
        Meta: [],
        id: 0,
        RobotIndex: 'noindex',
        RobotFollow: 'nofollow',
      }}
    />
  );
}

export default Chrisrecord;
